export default "__VITE_PUBLIC_ASSET__c1126f46__"